/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityHealthCheckResponse } from '../../models/community-health-check-response';

export interface AdminCheckCommunityHealthGet$Params {
}

export function adminCheckCommunityHealthGet(http: HttpClient, rootUrl: string, params?: AdminCheckCommunityHealthGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<CommunityHealthCheckResponse>> {
  const rb = new RequestBuilder(rootUrl, adminCheckCommunityHealthGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<CommunityHealthCheckResponse>;
    })
  );
}

adminCheckCommunityHealthGet.PATH = '/Admin/checkCommunityHealth';
